import React, { useState } from 'react';
import SpeedMenu from './SpeedMenu';

interface TimelineToolbarProps {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  onCrop: () => void;
  onResetSegments: () => void;
  /** The clip's default level: what a segment carrying none of its own plays at. */
  masterVolume: number;
  onMasterVolumeToggle: () => void;
  /** The clip's default speed, on the same terms. */
  playbackSpeed: number;
  onPlaybackSpeedChange: (speed: number) => void;
}

const TimelineToolbar: React.FC<TimelineToolbarProps> = ({
  onUndo, onRedo, canUndo, canRedo,
  onCrop, onResetSegments,
  masterVolume, onMasterVolumeToggle,
  playbackSpeed, onPlaybackSpeedChange,
}) => {
  const [speedOpen, setSpeedOpen] = useState(false);
  return (
    <div className="timeline-toolbar">
      <div className="timeline-toolbar-left">
        <button className="tt-btn" onClick={onUndo} disabled={!canUndo} title="Undo (Ctrl+Z)">
          <span className="tt-icon">↶</span><span className="tt-label">Undo</span>
        </button>
        <button className="tt-btn" onClick={onRedo} disabled={!canRedo} title="Redo (Ctrl+Y)">
          <span className="tt-icon">↷</span><span className="tt-label">Redo</span>
        </button>
        <div className="tt-divider" />
        <button className="tt-btn" onClick={onCrop} title="Crop (Ctrl+K)">
          <span className="tt-icon">⬜</span><span className="tt-label">Crop</span>
        </button>
        <button
          className="tt-btn"
          onClick={onResetSegments}
          title="Rebuild the timeline as four equal segments, discarding every per-segment edit"
        >
          <span className="tt-icon">⟲</span><span className="tt-label">Reset Segments</span>
        </button>
      </div>

      <div className="timeline-toolbar-right">
        <div className="tt-speed">
          <button
            className="tt-btn"
            onClick={() => setSpeedOpen(o => !o)}
            title="Clip speed — what a segment with no speed of its own plays at"
          >
            <span className="tt-icon">⏩</span><span className="tt-label">{playbackSpeed}x</span>
          </button>
          {speedOpen && (
            <SpeedMenu
              currentSpeed={playbackSpeed}
              onSelect={onPlaybackSpeedChange}
              onClose={() => setSpeedOpen(false)}
            />
          )}
        </div>
        <button
          className="tt-btn"
          onClick={onMasterVolumeToggle}
          title="Clip volume — what a segment with no level of its own plays at"
        >
          <span className="tt-icon">{masterVolume > 0 ? '🔊' : '🔇'}</span>
        </button>
      </div>
    </div>
  );
};

export default TimelineToolbar;
